/** @jsxImportSource @emotion/react */
"use client";

import Bugsnag from "@bugsnag/js";
import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import {
  matchSelectableGuide,
  useCurrentGuide,
  usePlayer,
} from "@packages/media";
import type { Track } from "@packages/sdk";
import { useAlert } from "@packages/ui";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import { SelectGuideList } from "./SelectGuideList.emotion";

export const SelectGuideContent = () => {
  const { currentItem, guides } = useCurrentGuide();
  const player = usePlayer();
  const { track } = useAnalytics();
  const alert = useAlert();
  const t = useTranslations();
  const analyticsProps = useMediaAnalyticsProps();

  if (currentItem?.type === "radio_song") return null;

  const options: Track[] = [];
  for (const guide of guides) {
    let closestTimeDiff: number = 1000000;
    let closestTimeTrack: Track | null = null;
    for (const track of guide.tracks) {
      const timeDiff = Math.abs(
        track.duration - currentItem.selected_audio.duration,
      );
      if (timeDiff < closestTimeDiff) {
        closestTimeDiff = timeDiff;
        closestTimeTrack = track;
      }
    }
    if (closestTimeTrack)
      options.push({ ...closestTimeTrack, guide_ids: guide.guide_ids });
  }

  return (
    <SelectGuideList
      key={"mediaMenu_selectGuideList"}
      onGuideSelection={(newGuides) => {
        const choice = options.find((opt) =>
          matchSelectableGuide(opt.guide_ids, newGuides),
        );
        if (choice) {
          void track({
            event: HallowAnalyticsEvent.ChangedGuide,
            properties: {
              ...analyticsProps,
              guides: choice.guide_ids,
            },
          });
          return player?.switchTo(choice);
        } else {
          Bugsnag.notify(
            new Error(
              `Invalid guide selection ${newGuides} for prayer ${currentItem.prayer.id}`,
            ),
          );
          void alert.show({
            title: t("general_word_error"),
            description: t("general_error_message"),
          });
        }
      }}
      options={guides}
      selectedGuides={
        guides.find((g) =>
          matchSelectableGuide(
            g.guide_ids,
            currentItem?.selected_audio?.guide_ids,
          ),
        )?.guide_ids
      }
    />
  );
};
